import { heatFill, flameGrowth, FLAME_START } from '../lib/progressHeat'

// Completion-heat progress bar: cool → hot as it fills, with a flame at the leading
// edge on the home stretch. `frac` is 0..1 (watched / total). See lib/progressHeat.
// flame: show the flame at the leading edge on the home stretch. Turn OFF on tiny bars
// whose parent clips overflow (e.g. poster-bottom bars) where the flame would be cut.
export function HeatBar({ frac, height = 4, track = 'rgba(var(--ink-rgb),0.10)', flame: flameProp = true, style }) {
  const f = Math.max(0, Math.min(1, Number(frac) || 0))
  // Growth 0..1 from FLAME_START upward — size and glow both scale with it, so the flame
  // builds as the series burns down instead of popping on at 85% (Jason 2026-07-27).
  const g     = flameGrowth(f)
  const flame = flameProp && f >= FLAME_START   // >= so it lights AT the threshold, not just past it
  const fSize = 9 + g * 6          // 9px just-lit → 15px finale
  const fBlur = 3 + g * 5          // glow tightens up as it grows
  return (
    <div style={{ position: 'relative', width: '100%', height, borderRadius: height, background: track, ...style }}>
      <div style={{
        position: 'relative', width: `${f * 100}%`, height: '100%', borderRadius: height,
        background: heatFill(f), minWidth: f > 0 ? 3 : 0,
        transition: 'width 0.45s var(--ease-soft), background 0.45s ease',
      }}>
        {flame && (
          <span aria-hidden="true" style={{
            position: 'absolute', right: -5, top: '50%', transform: 'translateY(-50%)',
            fontSize: fSize, lineHeight: 1,
            filter: `drop-shadow(0 0 ${fBlur}px rgba(255,120,40,${(0.45 + g * 0.4).toFixed(2)}))`,
            // Flicker speeds up slightly as it grows — a bigger fire is a busier one.
            '--nxa': `heatFlicker ${(1.05 - g * 0.25).toFixed(2)}s ease-in-out infinite`,
            transition: 'font-size 0.45s var(--ease-soft)',
          }}>🔥</span>
        )}
      </div>
      {flame && <style>{`@keyframes heatFlicker{0%,100%{transform:translateY(-50%) scale(1);opacity:0.92}50%{transform:translateY(-54%) scale(1.18);opacity:1}}`}</style>}
    </div>
  )
}
